import FeedbackIdeasPage from './FeedbackIdeas';

export default FeedbackIdeasPage;
